export const action_list = [
  "Merged",
  "Resolved Separately",
  "Split",
  "None",
  "None(OGS Restricted)",
  "Data Updated",
  "Query (OGS-use only)",
  "Deferred",
  "Resolved Single EID"
];

export const reason_list = [
  "2 Different People",
  "Address history provides link",
  "Address Match",
  "All data seems to match",
  "Alphanumeric RX Claims Member ID",
  "Already Resolved",
  "Alternate ID Match",
  "Alternate ID/Family ID match",
  "Alternate ID/HICN  Match",
  "Anonymous Address",
  "Baby or Newborn name",
  "C360 CPIN matches",
  "CDB look up using SSN",
  "CDB look up using SubID",
  "Concur with Verato Resolution",
  "Data Quality Issue",
  "Deferred Action to Capability Owner",
  "Different family lists",
  "Different FN or FN Initial",
  "Different FN/LN",
  "Different HICN/MBI",
  "Different Middle Initial",
  "Different SSNs",
  "Different UID",
  "DMG information insufficient",
  "Do Not Concur with Verato Resolution",
  "DOB Typo",
  "Dummy DOB",
  "Dummy name",
  "EID Not Found",
  "Email Match",
  "Employee Record",
  "Family ID Match",
  "Family lists match",
  "FN Incomplete",
  "FN Spacing/Concatenated",
  "FN Typo",
  "FN/LN Inverted",
  "Follow-up Required",
  "Gender Typo",
  "HC3 information insufficient",
  "HICN Match",
  "ICUE information insufficient",
  "LN Change",
  "LN Incomplete",
  "LN Spacing/Concatenated",
  "LN Typo",
  "MBI match",
  "Member ID partial match Source ID",
  "Member ID/Family ID Match",
  "MI spacing/concatenated",
  "Middle Initial Typo",
  "Middle Initial used as FN",
  "Middle Name uses as FN",
  "Nickname Matches Real Name",
  "No Matching Data in MDM or CDB",
  "OCD information insufficient",
  "OCD Member ID/Partial Match Source ID",
  "Parent/Child being compared",
  "Pet Name Record",
  "PH Policy # 99999",
  "Phone Number Match",
  "PID Policy# Match",
  "Potential Glue Members",
  "Potential Overlay",
  "Rx Claims Member ID match",
  "Rx Claims Member ID partial match",
  "Rx confirmed SSN match -FN/LN/DOB match",
  "RXCC Information Insufficient",
  "RXCL1 CouponPRX Record",
  "Siblings being compared",
  "Single EID",
  "Singleton",
  "Singleton Record Information Insufficient",
  "Split Not Required",
  "Spouse’s DOB",
  "Spouse’s SSN Populating",
  "Spouses being compared",
  "SSN links to address history",
  "SSN Match",
  "SSN Typo",
  "SSN/Alternate ID Match",
  "SSN/Family ID Match",
  "SSN/HICN Match",
  "SSN/Member ID Match",
  "SSN/RX Member ID match",
  "SSN/Subscriber ID Match",
  "Subscriber ID Match",
  "Subscriber ID partial match Source ID",
  "Subscriber ID populating in SSN field",
  "Subscriber ID/Alternate ID Match",
  "Subscriber ID/Family ID Match",
  "Subscriber ID/HICN Match",
  "Subscriber ID/Member ID Match",
  "Subscriber ID/RX Member ID Match",
  "Twins",
  "UID information insufficient",
  "Unique FN/LN combination",
  "Unique FN/LN/DOB combination"
];
